import ClearIcon from '@mui/icons-material/Clear'
import { Box, Stack, Typography } from '@mui/material'
import cls from 'classnames'

import Button from '@/components/base/Button'
import useTrans from '@/hooks/useTrans'

type ModalLayoutProps = HocProps & {
  title: string
  onClose?: () => void
  isDisplayBtnClose?: boolean
  footer?: string
  isInsideDrawer?: boolean
  customWidthClasses?: string
}

const Container = ({ children, title, onClose, isDisplayBtnClose, footer, isInsideDrawer, customWidthClasses }: ModalLayoutProps) => {
  const trans = useTrans()

  return (
    <Stack className={cls('bg-[#1E2735] iw:bg-white text-white iw:text-[#000E0F] rounded-[16px]', {
      'rounded-b-none': isInsideDrawer,
      [`${customWidthClasses || 'w-[343px] sm:w-[484px]'} max-h-[90vh] overflow-auto absolute top-1/2	left-1/2 translate-x-[-50%] translate-y-[-50%]`]: !isInsideDrawer,
    })}>
      <Box className="px-6 py-[11px] bg-[#1A2330] iw:bg-[#F6FBFF] rounded-t-[16px]" display="flex" justifyContent="space-between">
        <Typography className="text-xl font-bold">{title}</Typography>
        <ClearIcon className="cursor-pointer" onClick={onClose} />
      </Box>
      <Box className="p-6">
        {children}
        {isDisplayBtnClose && (
          <Button
            onClick={onClose}
            data-testid="btn-close"
            className="mt-[12px]"
            fullWidth
            variant="outlined"
            size="xl"
          >
            {trans.wrapped_token.btn_close}
          </Button>
        )}
        {footer && <Typography className="text-center text-xs text-gray-500 mt-2 relative top-2">{footer}</Typography>}
      </Box>
    </Stack>
  )
}

export default Container
